import _ from 'lodash'
import {MutationTree} from 'vuex'
import {ModerationState} from '@/modules/cms/modules/moderation/store/index'
import ModerationVote from '@/modules/cms/modules/moderation/model/ModerationVote';

/**
 * Mutaciones para el modulo de moderación
 */
export enum MutationTypes {
    SetCurrentModerationVote = 'SET_CURRENT_MODERATION_VOTE',
    SetCurrentModerationVoteList = 'SET_CURRENT_MODERATION_VOTE_LIST',
    UpdateCurrentModerationVoteField = 'UPDATE_CURRENT_MODERATION_VOTE_FIELD',
    AddVoteToList = 'ADD_VOTE_TO_LIST',
    ToggleCurrentUserCanModerate = 'TOGGLE_CURRENT_USER_CAN_MODERATE',
    TogglePermissionFetched = 'TOGGLE_PERMISSION_FETCHED',
}

const mutations: MutationTree<ModerationState> = {
    /**
     * Establece el voto actualmente en edición por el usuario
     *
     * @param state
     * @param vote
     */
    [MutationTypes.SetCurrentModerationVote]: (state, vote: ModerationVote) => state.currentVote = vote,

    /**
     * Establece la lista de votos de moderación actualmente mostrada al usuario
     *
     * @param state
     * @param list
     */
    [MutationTypes.SetCurrentModerationVoteList]: (state, list: ModerationVote[]) => state.currentVoteList = list,

    /**
     * Actualiza uno de los campos del voto de moderación actualmente en edición por el usuario
     * @param state
     * @param payload
     */
    [MutationTypes.UpdateCurrentModerationVoteField]: (state, payload: {field: string, value: any}) => {
        _.set(state.currentVote, payload.field, payload.value)
    },

    /**
     * Registra un voto en la lista actual de votos, si ya existe sustituye el nuevo por
     * el antiguo
     *
     * @param state
     * @param vote
     */
    [MutationTypes.AddVoteToList]: (state, vote: ModerationVote) => {
        const index = state.currentVoteList.findIndex(v => v.id === vote.id)
        if (index === -1) {
            state.currentVoteList.push(vote)

            return
        }

        state.currentVoteList.splice(index, 1, vote)
    },

    /**
     * Habilita o des-habilita la opción que indica si el usuario actual de la aplicación
     * puede moderar contenido
     *
     * @param state
     * @param canModerate
     */
    [MutationTypes.ToggleCurrentUserCanModerate]: (state, canModerate: boolean) => {
        state.currentUserCanModerate = canModerate
    },

    /**
     * Activa o desactiva el parámetro que indica si ya se ha obtenido del servidor el permisos
     * de moderación
     *
     * @param state
     * @param fetched
     */
    [MutationTypes.TogglePermissionFetched]: (state, fetched: boolean) => state.permissionFetched = fetched,
}

export default mutations
